export default __webpack_public_path__ + "static/media/Snd3.f3e4e7d3.mp3";